import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SectionContainer from "@project/templates/home/SectionContainer";
import Surtitle from "@project/components/Surtitle";
import DynamicContainer from "@project/templates/home/DynamicContainer";
const TargetSection = (props) => {
    const { page } = props;
    const { contents } = page || {};
    const { infosBlock, targetDynamic, surtitleOfferTargetPart, titleOfferTargetPart, descriptionOfferTargetPart, } = contents;
    return (_jsx(SectionContainer, { children: _jsxs(Stack, { direction: { xs: "column", lg: "row" }, spacing: { xs: 4, lg: 8 }, sx: { alignItems: "stretch", justifyContent: "space-between" }, children: [_jsxs(Stack, { spacing: 2, sx: {
                        "@media (min-width:1200px)": {
                            maxWidth: 520,
                        },
                        "@media (min-width:1440px)": {
                            maxWidth: 600,
                        },
                    }, children: [_jsx(Surtitle, { title: surtitleOfferTargetPart }), _jsx(Typography, { component: "h2", variant: "h2", sx: {
                                color: "text.primary",
                                fontSize: { xs: "20px", md: "28px" },
                                lineHeight: { xs: "130%", md: "150%" },
                                letterSpacing: { xs: "-0.02em", md: "0.02em" },
                            }, children: titleOfferTargetPart }), descriptionOfferTargetPart && (_jsx(Typography, { variant: "body1", sx: {
                                color: "text.secondary",
                                fontSize: { xs: "14px", md: "16px" },
                                lineHeight: { xs: "150%", md: "160%" },
                            }, children: descriptionOfferTargetPart })), _jsx(DynamicContainer, { children: targetDynamic })] }), infosBlock] }) }));
};
export default TargetSection;
